import { lazy, Suspense } from "react";

import { Spinner } from "@app/components/spinners/spinner";

const ImporterExperimentalPageProjectScenario = lazy(() => {
  return new Promise<{ default: React.FC }>((resolve, reject) => {
    import("experimental/lib")
      .then((lib) => {
        resolve({
          default: () => <lib.default.PageProjectScenario />,
        });
      })
      .catch(reject);
  });
});

export const LazyExperimentalPageProjectScenario = () => {
  return (
    <Suspense fallback={<Spinner height={"100vh"} />}>
      <ImporterExperimentalPageProjectScenario />
    </Suspense>
  );
};
